import * as React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import {
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query'
import { createPersistedDashboardQueryClient } from 'hooks/dashboard/persistDashboardQueryCache'
import { AuthProvider } from './contexts/AuthContext'
import { OfferProvider } from './contexts/OfferContext'
import { AssistantProvider } from './components/assistant'
import { AppRoutes } from './router/AppRoutes'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RootErrorBoundary } from './components/RootErrorBoundary'
import { PwaChrome } from './components/PwaChrome'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { SnackbarProvider, closeSnackbar } from 'notistack'
import 'dayjs/locale/en'

dayjs.extend(isBetween)
import { Button } from '@mui/material'


const queryClient = new QueryClient()

const tanstackQueryClient = createPersistedDashboardQueryClient()

// Configure dayjs locale globally
dayjs.locale('en')

export default function App() {
  return (
    <RootErrorBoundary>
      <TanstackQueryClientProvider client={tanstackQueryClient}>
        <QueryClientProvider client={queryClient}>
          {/* <ReactScan /> */}
          <AuthProvider>
            <OfferProvider>
              <AssistantProvider>
              <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                dense
                preventDuplicate
                action={snackbarKey => (
                  <Button onClick={() => closeSnackbar(snackbarKey)} size='small' sx={{ color: 'white' }}>
                    Dismiss
                  </Button>
                )}
              >
                <PwaChrome />
                <AppRoutes />
                {process.env.NODE_ENV === 'development' && <ReactQueryDevtools position='right' />}
              </SnackbarProvider>
              </AssistantProvider>
            </OfferProvider>
          </AuthProvider>
        </QueryClientProvider>
      </TanstackQueryClientProvider>
    </RootErrorBoundary>
  )
}
